export const getColumn = (columnNumber, array, index) => {
  const arrayLength = array.length + 1;
  let column = 2;

  if (index + 1 <= arrayLength / 2) {
    column = 1;
  }

  return columnNumber === column;
};
